// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"339":"grab","443":"about"}[chunkId] + "." + {"339":"8d1b8a24","443":"73429113"}[chunkId] + ".js";
};